<template>
    <div>
        <hr />
        <div class="col-12 mt-1 mb-3">
            <h5 class="mt-0 font-size-14 text-primary">Formatos:</h5>
        </div>
        <!-- Formulário default -->
        <task-formats-form :task_id="task_id" :id="null" @pushData="pushData" v-if="userAdmin === 1" />
        <!-- Formulário resultados -->
        <template v-if="items.length > 0">
            <transition-group name="fade" tag="div" class="lista-results mt-3">
                <task-formats-form-update v-for="p in items" :key="p.id" :task_id="task_id" :id="p.id"
                    :formato="p.formato" :qtda="p.qtda" :qtda_templatizada="p.qtda_templatizada"
                    :versionamento="p.versionamento" :data_entrada_briefing="p.data_entrada_briefing"
                    :data_entrada="p.data_entrada" :data_saida="p.data_saida" :status="p.status" :userAdmin="userAdmin"
                    :tipo_de_entrega="p.tipo_de_entrega" @pushData="pushData" @sliceData="sliceData"
                    @updateData="updateData" />
            </transition-group>
        </template>
        <!-- Quantidades por segmento -->
        <hr />
        <div class="col-12 mt-1 mb-3">
            <h5 class="mt-0 font-size-14 text-primary">Quantidades por segmentos:</h5>
        </div>
        <task-quantidades :task_id="task_id" :userAdmin="userAdmin" @updateSegmentos="updateSegmentos" />
        <hr />
        <!-- Quantidades total -->
        <div class="col-12 mt-1 mb-2">
            <h5 class="mb-3 font-size-14 text-primary">Quantidades total:</h5>
        </div>
        <task-quantidades-total :segmento="segmentosTotal" :items="items" :nao_correntistas="naoCorrentistasTotal" />
    </div>

</template>

<script>
import TaskFormatsForm from "./TaskFormatsForm.vue";
import TaskFormatsFormUpdate from "./TaskFormatsFormUpdate.vue";
import TaskQuantidades from './TaskQuantidades.vue'
import TaskQuantidadesTotal from './TaskQuantidadesTotal.vue'

export default {
    props: {
        task_id: {
            type: [String, Number]
        },
        userAdmin: { type: [Number, String], required: false }
    },
    components: {
        TaskFormatsForm,
        TaskFormatsFormUpdate,
        TaskQuantidades,
        TaskQuantidadesTotal
    },
    data() {
        return {
            items: [],
            isLoading: false,
            newItem: [],
            formatosTotal: 0,
            segmentosTotal: 0,
            naoCorrentistasTotal: 0
        };
    },
    created() {
        this.loadData();
    },
    methods: {
        sliceData(id) {
            let all = this.items;
            let novos = all.filter(a => a.id != id);
            this.items = novos;
        },
        pushData(d) {
            //this.items.push(d)
            this.items.unshift(d)
        },
        loadData() {
            const _this = this;
            _this.isLoadding = true
            setTimeout(function () {
                _this.loadDataDelay();
            }, 1000)
        },
        async loadDataDelay() {
            const options = this.$getAPIHeaders(
                "GET",
                `task-properties-all/${this.task_id}`
            );
            await this.axios(options)
                .then(response => {

                    if (response.data) {
                        const apiData = response.data.data;
                        this.items = apiData.items || [];
                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        updateSegmentos(segmentos, nao_correntistas) {
            this.segmentosTotal = segmentos;
            this.naoCorrentistasTotal = nao_correntistas;
            console.log('segmentosTotal: ', this.segmentosTotal)
            console.log('naoCorrentistasTotal: ', this.naoCorrentistasTotal)
        },
        updateData(data) {
            this.items.map(e => {
                if (e.id === data.id) {
                    e[data.type] = data.value;
                }
            })
            console.log('updateData formatos', data)
        }
    }
}
</script>
<style lang="css" scoped>
.lista-results {
    border-radius: 8px;
    padding: 30px 15px 0px 15px;
    border: 1px solid #d2d6da;
    margin-bottom: 16px;
}

.lista-results>div+div {
    border-top: 1px solid #d2d6da;
    padding-top: 30px;
    margin-top: 10px;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>